import React, { useState } from 'react'; // 1. Added useState
import { Droppable } from 'react-beautiful-dnd';
import Ticket from '../../../interfaces/ticket/Ticket';
import TicketCard from './TicketCard';
import './IssuesPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';

interface SprintLaneProps {
    sprintId: string;
    sprintName: string;
    tickets: Ticket[];
    onTicketClick: (ticketId: string) => void;
}

const SprintLane: React.FC<SprintLaneProps> = ({ sprintId, sprintName, tickets, onTicketClick }) => {
    // 2. State to track visibility
    const [isExpanded, setIsExpanded] = useState(true);

    const toggleCollapse = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="sprint-lane">
            {/* 3. Added a clickable header area */}
            <div
                className='flex justify-between items-center mb-1 cursor-pointer p-2 hover:bg-gray-100 transition-colors'
                onClick={toggleCollapse}
            >
                <div className="flex items-center align-middle gap-2">
                    {/* <span>{isExpanded ? '▼' : '▶'}</span> */}
                    {isExpanded ?
                        <FontAwesomeIcon icon={faAngleDown} /> :
                        <FontAwesomeIcon icon={faAngleRight} />
                }
                    <h3 className="m-0 p-0">{sprintName}</h3>
                </div>
                <p className="text-sm text-gray-500">{tickets.length} Tickets</p>
            </div>

            {/* 4. Conditional Rendering */}
            {isExpanded && (
                <Droppable droppableId={sprintId}>
                    {(provided) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className="ticket-list"
                        >
                            {tickets.map((ticket, index) => (
                                <TicketCard
                                    key={ticket.id}
                                    ticket={ticket}
                                    index={index}
                                    sprintView={false}
                                    onCardClick={onTicketClick}
                                />
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            )}
        </div>
    );
};

export default SprintLane;